// extracted by mini-css-extract-plugin
export default {"centeredContainer":"Login_centeredContainer__SMVyP","loginError":"Login_loginError__B7SDx"};